import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";

const SEO = ({ slug, title, description,canonicalUrl }) => {
  const [seoData, setSeoData] = useState({
    title: title ?? null,
    description: description ?? null,
  });
  const [canonical, setCanonical] = useState(canonicalUrl || null);

  useEffect(() => {
    const fetchSEOData = async () => {
      try {
        const response = await axios.get(
          `https://descorealestate.com/admin/api/seo/seo_key?slug=${slug}`
        );

        const data = response.data.data[0];

        if (data) {
          const newTitle = data.title?.trim() || "Desco Real Estate";
          const newDescription =
            data.description?.trim() ||
            "Desco Real Estate - Your trusted partner for Dubai real estate investments";

          setSeoData({ title: newTitle, description: newDescription });

          // Manually update window/document (optional)
          document.title = newTitle;
          const metaDesc = document.querySelector('meta[name="description"]');
          if (metaDesc) {
            metaDesc.setAttribute("content", newDescription);
          }
        }
      } catch (error) {
        console.error("Failed to fetch SEO data:", error);
        const fallbackTitle = "Desco Real Estate";
        const fallbackDesc =
          "Desco Real Estate - Your trusted partner for Dubai real estate investments";

        setSeoData({ title: fallbackTitle, description: fallbackDesc });

        // Fallback DOM update
        document.title = fallbackTitle;
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
          metaDesc.setAttribute("content", fallbackDesc);
        }
      }
    };

    // Call API only if title or description not provided
    if (!title || !description) {
      fetchSEOData();
    } else {
      // Manually update window/document for provided props
      document.title = title;
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute("content", description);
      }
    }

    if (!canonicalUrl && typeof window !== "undefined") {
      setCanonical(window.location.href);
    }
  }, [slug, title, description]);

  const finalSEO = {
    title: seoData.title || "Desco Real Estate",
    description:
      seoData.description ||
      "Desco Real Estate - Your trusted partner for Dubai real estate investments",
  };

  return (
    <Helmet>
      <title>{finalSEO.title}</title>
      <meta name="description" content={finalSEO.description} />

      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} />} 
      
      <meta key="og-title" property="og:title" content={finalSEO.title} />
      <meta
        key="og-desc"
        property="og:description"
        content={finalSEO.description}
      />
      <meta key="twitter-title" name="twitter:title" content={finalSEO.title} />
      <meta
        key="twitter-desc"
        name="twitter:description"
        content={finalSEO.description}
      />

      <meta name="seo-updated" content={new Date().getTime()} />
    </Helmet>
  );
};

export default SEO;
